import PortfolioCrazy from "./PortfolioCrazy"

export default PortfolioCrazy